// Define channel names
export const Channels = {
  QBD: "Quickbooks Desktop",
};

// Define page size options for paging
export const pageSizeOptionsPaging = [10, 20, 50, 100];
// Define default roles
export const defaultRoles = ["Admin 3nStar"];
